import { MSTenantEntity } from 'jamespot-user-api';
import { CSSEntity, CSSEntityAvatar } from '../../components/EntityItem';
import { JRCFile } from '../../../JRCFile/JRCFile';
import { DEFAULT_FOLDER_COLOR } from '../../drive.const';
import { EntityItemTitle } from '../../components/EntityItemTitle';
import * as React from 'react';

export const TenantEntityItem = ({
    entity,
    initialFolderColor,
    onClick,
}: {
    entity: MSTenantEntity;
    initialFolderColor?: string;
    onClick: () => void;
}) => {
    return (
        <CSSEntity>
            <CSSEntityAvatar>
                <JRCFile
                    uri={undefined}
                    size={2}
                    mimetype={'folder/'}
                    color={initialFolderColor ?? DEFAULT_FOLDER_COLOR}
                />
            </CSSEntityAvatar>
            <EntityItemTitle title={entity.title} type={'folder'} useNavigation={true} onClick={onClick} />
        </CSSEntity>
    );
};
